// extracted by mini-css-extract-plugin
export default {"container":"SimpleColorPicker_container__-Cb5d","color-picker":"SimpleColorPicker_color-picker__nYwsa"};